import React, { useState, useEffect } from 'react'
import { History, Location } from 'history'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { Table } from 'antd'
import { Col } from 'styled-bootstrap-grid'
import { ColumnsType } from 'antd/lib/table'
import { getUserchats, getTotalUserChats } from '../../features/userchat/selectors'
import { UserChatActions } from '../../features/userchat/actions'

import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'
import { Row } from '../../components/Grid'
import { UserChat } from '../../features/userchat/types'

interface UserChatsProps {
  history?: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const UserChats: React.FC<UserChatsProps> = () => {
  const dispatch = useDispatch()
  const userChats = useSelector(getUserchats)

  const total = useSelector(getTotalUserChats)
  const [offset, setOffset] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    dispatch(UserChatActions.fetchUserChats(20, offset))
  }, [dispatch, offset])

  const onPageChange = (page: number, pageSize: number | undefined) => {
    if (page && pageSize) {
      setOffset((page - 1) * pageSize)
      setCurrentPage(page)
    }

    // console.log(`page: ${page}, pageSize: ${pageSize}`)
  }

  const columns: ColumnsType<UserChat> = [
    {
      title: 'id',
      dataIndex: 'id',
      sorter: (a: any, b: any) => a.id - b.id,
      sortDirections: ['ascend', 'descend', 'ascend'],
      defaultSortOrder: 'descend',
      width: '10%'
    },
    {
      title: 'ID User',
      dataIndex: 'userId',
      width: '10%',
      sorter: (a: any, b: any) => a.userId - b.userId
    },
    {
      title: 'user message',
      dataIndex: 'message',
      width: '30%'
    },
    {
      title: 'bloccato',
      dataIndex: 'blocked',
      width: '5%',
      // eslint-disable-next-line react/display-name
      render: (_text: string, record: any) => {
        return record.blocked ? (
          <span className="message-blocked">SI</span>
        ) : (
          <span className="message-not-blocked">NO</span>
        )
      }
    },
    {
      title: 'ID Angel',
      dataIndex: 'profileId',
      width: '20%'
    },
    {
      title: 'angel message',
      dataIndex: 'chatMessage',
      render: (text: string, record: any) => {
        // console.log(record)
        return record.chatMessage && record.chatMessage.first
      }
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Chat</Title>
        <Row>
          <Col md={12} alignSelf="center">
            <Table
              columns={columns}
              rowKey={(record: UserChat) => record.id}
              dataSource={_.map(userChats)}
              pagination={{
                defaultCurrent: currentPage,
                pageSize: 20,
                total,
                current: currentPage,
                onChange: onPageChange
              }}
            />
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
